import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Slack Send Message v1 Configuration Validator
 * Validates Slack message configuration including connection, channel, and content
 */
export const Slack_Send_Channel_Message_1_ConfigValidator = z.object({
    slackConnection: requiredString('Slack Connection is required'),
    channel: requiredString('Channel is required'),
    message: requiredString('Message is required')
});
//# sourceMappingURL=slack-send-channel-message-1.js.map